import { forwardRef, Provider } from "@angular/core";
import { NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";

export const provideNgValueAccessor = <T>(ComponentClass: T): Provider => {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ComponentClass),
    multi: true,
  };
};

export const provideNgValidators = <T>(ComponentClass: T): Provider => {
  return {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => ComponentClass),
    multi: true,
  };
};

export const provideNgAsyncValidators = <T>(ComponentClass: T): Provider => {
  return {
    provide: NG_ASYNC_VALIDATORS,
    useExisting: forwardRef(() => ComponentClass),
    multi: true,
  };
};
